import type { ReactNode } from "react";
import { StyleSheet, View, type StyleProp, type ViewStyle } from "react-native";

import { useAppTheme } from "@/theme/paper-theme";
import { spacing } from "@/theme/tokens";

/**
 * The chrome every marketing section below the hero shares: a hairline top
 * rule in the theme's `outlineVariant`, the tall vertical rhythm, and the
 * page's one horizontal gutter (`spacing.md` — the column itself carries no
 * inset, see routes/index.tsx). Callers add their own variance — usually a
 * `gap` — through `style`.
 *
 * Named `MarketingSection` because `routes/privacy.tsx` already has a local
 * `Section` meaning a policy sub-heading; the two are different things.
 */
export function MarketingSection({
  children,
  style,
}: {
  children: ReactNode;
  style?: StyleProp<ViewStyle>;
}) {
  const theme = useAppTheme();

  return (
    <View
      style={[
        styles.section,
        { borderTopColor: theme.colors.outlineVariant },
        style,
      ]}
    >
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  section: {
    borderTopWidth: StyleSheet.hairlineWidth,
    paddingTop: spacing.xxxl,
    paddingBottom: spacing.xxxl,
    paddingHorizontal: spacing.md,
  },
});
